import Vue from 'vue'
import Vuex from 'vuex'
import userStore from './modules/userStore'
import adminStore from './modules/adminStore'
import common from './modules/common/'


Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    userStore,
    adminStore,
    common
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js